export default {
  lista: [],
  estaCarregando: false,
  carregandoInfo: '',
  paginaAtual: 1,
  totalItens: null,
  todosItensCarregados: false,
  itemSelecionadoID: null,
  filtrosAgenda: {
    functionario: null,
    sala_franqueada: null,
    data: null
  },
  itemSelecionado: {
    descricao: null
  },
  filtros: {
    funcionario: null,
    data: ''
  }
}
